import { loggedInUserHasRole } from '../lib'

export const hasCharityEditPermission = () => loggedInUserHasRole('MYTOMRA_CHARITIES_WRITE')
export const hasViewCharitiesPermission = () => loggedInUserHasRole('MYTOMRA_CHARITIES_READ')
export const hasNotesWritePermission = () => loggedInUserHasRole('MYTOMRA_MANAGER_NOTES_WRITE')
